import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import services from '../../services';

const UnlinkConfirmation = ({ show, onHide, handleYes, authUrlData, accountInfo, setIsLoading }) => {
    const handleCopy = () => {
        const url = "https://myaccount.google.com/connections?gar=WzJd&continue=https%3A%2F%2Fmyaccount.google.com%2Fsecurity%3Fgar%3DWzJd%26hl%3Den_GB%26utm_source%3DOGB%26utm_medium%3Dact&hl=en_GB&utm_source=OGB&utm_medium=act";
        if (!navigator.clipboard) {
            try {
                const textarea = document.createElement('textarea');
                textarea.value = url;
                document.body.appendChild(textarea);
                textarea.select();
                document.execCommand('copy');
                document.body.removeChild(textarea);
                toast.success('URL copied to clipboard!');
            } catch (err) {
                console.error('Fallback copy failed:', err);
                toast.error('Failed to copy URL. Please copy manually.');
            }
            return;
        }

        navigator.clipboard.writeText(url)
            .then(() => {
                toast.success('URL copied to clipboard!');
            })
            .catch((err) => {
                console.error('Clipboard API failed:', err);
                try {
                    const textarea = document.createElement('textarea');
                    textarea.value = url;
                    document.body.appendChild(textarea);
                    textarea.select();
                    document.execCommand('copy');
                    document.body.removeChild(textarea);
                    toast.success('URL copied to clipboard!');
                } catch (fallbackErr) {
                    console.error('Fallback copy failed:', fallbackErr);
                    toast.error('Failed to copy URL. Please copy manually.');
                }
            });
    };

    return (
        <Modal show={show} onHide={onHide} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title className='md:py-[0.6vw]'>
                    Unlink this account?
                </Modal.Title>
            </Modal.Header>

            <Modal.Body style={{ maxHeight: '500px', overflow: 'auto' }}>
                <p className="text-gray-700 mb-4">
                    Are you sure you want to unlink this account? This will redirect you to Google settings.
                </p>
                {authUrlData && authUrlData.length > 0 ? (
                    <div className="py-2">
                        <table className="min-w-full bg-white border border-gray-200 rounded-xl shadow-md overflow-hidden">
                            <thead>
                                <tr className="bg-gray-50 border-b-2 border-gray-200">
                                    <th className="px-4 py-3 text-left text-xs font-semibold text-black uppercase">Name</th>
                                    <th className="px-4 py-3 text-left text-xs font-semibold text-black uppercase">Email</th>
                                    <th className="px-4 py-3 text-left text-xs font-semibold text-black uppercase">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {authUrlData.map((item, index) => (
                                    <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                                        <td className="px-4 py-2 text-sm text-gray-800 whitespace-nowrap">
                                            {accountInfo?.name || '-'}
                                        </td>
                                        <td className="px-4 py-2 text-sm text-gray-800 whitespace-nowrap">
                                            {accountInfo?.email || '-'}
                                        </td>
                                        <td className="px-4 py-2 text-sm text-gray-800 whitespace-nowrap">
                                            <div className="flex gap-2">
                                                <button
                                                    onClick={() => handleCopy()}
                                                    className="text-xs px-2 py-1 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-100"
                                                    title="Copy URL to clipboard"
                                                >
                                                    Copy URL
                                                </button>

                                                <button
                                                    onClick={handleYes}
                                                    className="text-xs px-2 py-1 border border-red-400 text-red-600 rounded-md hover:bg-red-50"
                                                    title="Unlink Account"
                                                >
                                                    Unlink
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <div className="text-center text-gray-500 py-8">No authorization data available.</div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide} style={{ fontSize: 'small', textTransform: 'none' }}>
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default UnlinkConfirmation;
